import { logger } from 'services/logger';

export default function gtagEvent(eventName: string, parameters?: null | Record<string, unknown>) {
    try {
        if (window.gtag) {
            window.gtag('event', eventName, parameters ?? undefined);
        }
    } catch (e) {
        logger.error(e);
    }
}
